<template>
<div class="chapter">
<div class="inner_page">
<h2>Acknowledgments</h2>
<p class="initial"> </p>
<p class="initial"> </p>
<p class="initial"> </p>
<p class="p-in1">My editor is Dorothy O’Brien, tireless, cheerful, all-noticing. My friend and longtime editor Donna Martin suggested the yearbook approach to the annual volume. The design is by Cameron Poulter, the typographical genius of Hyde Park. </p>
<p class="p-in">My thanks to production editor Christi Clemons Hoffman, who renders Cameron’s design into reality. John Yuelkenbeck at Alias Creative Group is the compositor who has worked diligently on the series for years. I have been blessed with the expert and discriminating editing of Laura Emerick, Miriam Di Nunzio, Darel Jevins, Jeff Johnson, and Teresa Budasi at the <em>Chicago Sun-Times</em>; Sue Roush at Universal Uclick; and Michelle Daniel and David Shaw at Andrews McMeel Publishing. For much advice and counsel, thanks to Jim Emerson and John Barry of <a href="http://www.rogerebert.com" target="_blank">www.rogerebert.com</a>. </p>
<p class="p-in">Many thanks are also due to Marsha Jordan at WLS-TV. My gratitude goes to Carol Iwata, my expert personal assistant, and to Gregory Isaac, who is a computer whiz and invaluable aide-de-camp. I must also thank those who have given me countless observations and corrections, including Peter Debruge, Jana J. Monji, and Troylene Ladner. </p>
<p class="p-in">And special thanks and love to my wife, Chaz, who was always at my side during a difficult illness, helped see three books through the press during that time, and was a cheerleader for this one. I am so grateful to her as we once again, relieved, enter a period of good health.</p>
<p class="initial"> </p>
<p class="p-in1">R<span class="small">OGER</span> E<span class="small">BERT</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?0753085d